<head-meta [title]="this.title" />
<app-help-button src="/assets/help/firmware/detail.md" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <ng-container *ngrxLet="firmware$ as firmware; error as e; complete as c">
                @if(firmware) {
                    <div class="navbar bg-base-100">
                        <div class="flex-none">
                          <a routerLink="/firmware" routerLinkActive="active" class="btn btn-square btn-ghost text-primary"><fa-icon [icon]="faArrowLeft" class="w-5"></fa-icon></a>
                        </div>
                        <div class="flex-1">
                          <h1 class="h1 ml-4">{{firmware.name}}</h1>
                        </div>
                        <div class="flex-none">
                            @if(this.auth.has('firmware_update')) {
                                <button [routerLink]="'/firmware/' + this.id + '/edit'" routerLinkActive="active" class="btn btn-ghost text-primary">
                                    <fa-icon [icon]="faPenToSquare" class="w-5"></fa-icon> Edit
                                </button>
                            }
                        </div>
                    </div>
                    <hr class="hr" />
                    <div class="overflow-hidden bg-white shadow sm:rounded-lg">
                        <div class="border-t border-gray-100">
                            <dl class="divide-y divide-gray-100">
                                <div>
                                    <app-detail-display title="Firmware Version" [value]="firmware.firmware_version.toString()" />
                                </div>
                                <div>
                                    <app-detail-display title="Firmware S3 Path" [value]="firmware.s3_path.toString()" />
                                </div>
                                <div>
                                    <app-detail-display title="Signed Url" [value]="firmware.s3_signed_url" />
                                </div>
                                <div>
                                    <app-detail-display title="Checksum" [value]="firmware.sha256_checksum" />
                                </div>
                                @if(this.auth.has('firmware_update')) {
                                    <div>
                                        <app-created-updated-display [entity]="firmware" />
                                    </div>
                                }
                            </dl>
                        </div>
                    </div>
                }
                <app-loading-error-block [error]="e?.error" [complete]="c" />
            </ng-container>
        </div>
    </div>
</article>